import React, { Component } from 'react'
import Chat from './Chat'
import Notice from './Notice'
import style from './style.module.less'
import store from './store'
import { observer } from 'mobx-react'
import Support from './Support'
import { isNewOpen } from '@util'
@observer
export default class extends Component {
  render() {
    const { bottom } = store
    return (
      <div
        id="bottomFloat"
        className={style.message}
        style={{ bottom: bottom }}
      >
        {!isNewOpen() && <Support />}
        <Notice />
        {!isNewOpen() && <Chat />}
      </div>
    )
  }
}
